export default __webpack_public_path__ + "static/media/3142.97908406.jpg";